import styled, { Color } from '../../config/theme'

const List = styled.dl`

`

const Container = styled.div< {big: boolean }>`
margin-bottom: ${props => props.big ? '20px' : '10px'};
  display: flex;
`

const Term = styled.dt`
  color: ${props => props.theme.color.gray};
`

const Description = styled.dd<{ color?: Color }>`
  color: ${props => props.theme.color[props.color || 'black']};

  word-break: break-word;
  
  margin-left: 5px;
`

export {
  List,
  Term,
  Container,
  Description,
}
